module.exports = __webpack_public_path__ + "img/GithubIcon.1ce5a52f.svg";